var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18n from 'i18next';
import { setCookieLocale } from '../cookies/setCookieLocale';
export var changeLanguage = function (locale, options) {
    var changeLanguageOptions = __assign({ updateCookie: true }, options);
    i18n.changeLanguage(locale);
    if (changeLanguageOptions.updateCookie) {
        setCookieLocale(locale, options === null || options === void 0 ? void 0 : options.cookieDomain);
    }
};
export var language = function () { return i18n.language; };
